import React from 'react';
import PropTypes from 'prop-types';
import { Field, CardTitle } from '@cordata/buffet';
import { useFormikContext } from 'formik';
import { camelCase, capitalize } from 'lodash';

import { Dropzone } from '~/components';

const transformOption = label => ({
  label,
  value: camelCase(label),
});

const DOC_TYPES = [
  'Link',
  'Image',
  'PDF',
  'Text',
].map(transformOption);

const convertDocType = dt => {
  switch (dt) {
    case 'json':
      return 'application/json';
    case 'pdf':
      return 'application/pdf';
    case 'image':
      return 'image/*';
    case 'text':
    default:
      return 'text/*';
  }
};

const Fields = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <>

      <fieldset disabled={disabled}>
        <Field
          name="docType"
          type="radio-group"
          options={DOC_TYPES}
          inline
          required
        />
      </fieldset>

      {values.docType && (
        <fieldset>
          <CardTitle>{capitalize(values.docType)} Information</CardTitle>

          <Field name="title" required />

          <Field name="description" type="textarea" />

          {values.docType !== 'link' && (
            <>
              <Dropzone
                setFile={f => setFieldValue('file', f)}
                acceptFileTypes={convertDocType(values.docType)}
              />
            </>
          )}

          {values.docType === 'link' &&
            <Field name="link" type="url" required />}
        </fieldset>
      )}
    </>
  );
};

Fields.propTypes = {
  disabled: PropTypes.bool,
};

Fields.defaultProps = {
  disabled: false,
};

export default Fields;
